(function () {
    'use strict';
    /**
     * GSAP Helper module
     * Include gsap and scrolltrigger, and set up some defaults as needed for the Factory Tour
     *  - Register ScrollTrigger as a plugin for gsap
     *  - Set ScrollTrigger to ignoreMobileResize (thus preventing content jump/resizing on iOS)
     *  - Listen for resize events and set a variable, to be used for working around iOS address bar sizing
     *  - Provide access to prepared "Singleton" gsap and ScrollTrigger objects
     */
    define([
        'gsap/gsap',
        'gsap/ScrollTrigger'
    ], ({default: gsap}, {default: ScrollTrigger}) => {
        gsap.registerPlugin(ScrollTrigger);

        // more iOS fixes: prevent content resize (and jump) when address bar grows/shrinks
        ScrollTrigger.config({ignoreMobileResize: true});

        // provide "real" viewport height (i.e. minus iOS address bar space) to CSS
        window.addEventListener('resize', () => {
            document.documentElement.style.setProperty('--actual-viewport-height', `${window.innerHeight}px`);
        });

        return {
            getGsap: () => gsap,
            getScrollTrigger: () => ScrollTrigger
        };
    });
})();
